import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../utils/Logo";
import Logo2 from "../../images/logo.png";
import DropArrow from "../../images/dropArrow.png";

const Header = ({ setHeight }) => {
  const header = useRef(null);
  // ! LOGIN VARIABLE HERE
  const [condition] = useState(true);
  useEffect(() => {
    if (setHeight) setHeight(header.current.offsetHeight);
  }, [setHeight]);
  const openNav = () => {
    document.body.classList.add("nav_active");
  };
  const closeNav = () => {
    document.body.classList.remove("nav_active");
  };

  return (
    <header ref={header}>
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-9 col-sm-9 col-9 row">
            <div className="col-lg-3 col-md-3 col-sm-4 col-6  d-flex justify-content-center align-items-center">
              <svg
                onClick={openNav}
                style={{ cursor: `pointer` }}
                height="2rem"
                id="Layer_1"
                enableBackground="new 0 0 32 32"
                version="1.1"
                viewBox="0 0 32 32"
                width="2rem"
                xmlSpace="preserve"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
              >
                <path
                  d="M4,10h24c1.104,0,2-0.896,2-2s-0.896-2-2-2H4C2.896,6,2,6.896,2,8S2.896,10,4,10z M28,14H4c-1.104,0-2,0.896-2,2  s0.896,2,2,2h24c1.104,0,2-0.896,2-2S29.104,14,28,14z M28,22H4c-1.104,0-2,0.896-2,2s0.896,2,2,2h24c1.104,0,2-0.896,2-2  S29.104,22,28,22z"
                  fill="#fff"
                />
              </svg>
              <div className="close_bg" onClick={closeNav}></div>
              <div className="side-nav">
                <div className="list_your_experiance pb-5 pt-4">
                  <span onClick={closeNav} className="h1 text-white text-right d-block pointer-event px-4" style={{ cursor: `pointer` }}>&times;</span>
                  <Link to="/"><Logo color="#fff" bg="var(--color-light)" width="170px" /></Link>
                </div>
                <ul className="list-unstyled mt-3">
                  <li><Link onClick={closeNav} to="/">Home</Link></li>
                  <li className="line my-2"></li>
                  <li><Link onClick={closeNav} to="/about">About Us</Link></li>
                  <li><Link onClick={closeNav} to="/contact">Contact Us</Link></li>
                  <li className="line my-2"></li>
                  <li><Link onClick={closeNav} to="/login">Login</Link></li>
                  <li><Link onClick={closeNav} to="/signup">Sign Up</Link></li>
                  <li className="line my-2"></li>
                  <li><Link onClick={closeNav} to="/patient/profile">Profile</Link></li>
                  <li><Link onClick={closeNav} to="/patient/dashboard">Dashboard</Link></li>
                  <li><Link onClick={closeNav} to="/doctor/mydashboard">My Dashboard</Link></li>
                  <li><Link onClick={closeNav} to="/doctor/myprofile">My Profile</Link></li>
                  <li className="line my-2"></li>
                  <li><Link onClick={closeNav} to="/bookingstep1">Booking Step 1</Link></li>
                  <li><Link onClick={closeNav} to="/bookingstep2">Booking Step 2 & 3</Link></li>
                  <li><Link onClick={closeNav} to="/bookingstep4">Booking Step 4</Link></li>
                  <li><Link onClick={closeNav} to="/prescription">Prescription</Link></li>
                  <li className="line my-2"></li>
                  <li><Link onClick={closeNav} to="/videoconsultation/FrustratingMarchesDropBehind">Video Consultation</Link></li>
                </ul>
              </div>
            </div>

            <div className="col-lg-9 col-md-9 col-sm-8 col-6 text-center">
              <Link to="/">
                <img src={Logo2} className="logo" alt="LOGO" />
              </Link>
            </div>
          </div>
          <div className="col-lg-9  col-md-3 col-sm-3 col-3 text-right d-flex justify-content-end align-items-center">
            {condition ? (
              <div
                // to="/patient/profile"
                className="text-decoration-none text-white"
              >
                <span className="text-uppercase text-white d-inline-block mr-5 hide_on_med">
                  John Doe
                </span>
                
                   <div className="dropdown">
                <span className="dropbtn">
                <img
                  width="32px"
                  className="dropbtn d-inline-block ml-5"
                  src="https://www.docterio.com/static/profile_pics/acaf484db6c7bdd3.png"
                  alt=""
                />&ensp;
                 {window.innerWidth > 786 ? <img src={DropArrow} alt="arrow" />: ""}
                </span>
                  <div className="dropdown-content">
                      <Link to="/patient/profile">Profile</Link>
                      <Link to="/doctor/mydashboard">My Dashboard</Link>
                      <Link to="/doctor/myprofile">My Profile</Link>
                    </div>
                  
                </div>
              </div>
            ) : (
                <Link to="/login" className="text-decoration-none text-white">
                  <span className="text-uppercase text-white d-inline-block mr-5 hide_on_med">
                    Register as a doctor
                </span>
                  
                  <svg
                    className=" d-inline-block ml-5"
                    width="32px"
                    fill="#fff"
                    viewBox="0 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 2.66663C8.64002 2.66663 2.66669 8.63996 2.66669 16C2.66669 23.36 8.64002 29.3333 16 29.3333C23.36 29.3333 29.3334 23.36 29.3334 16C29.3334 8.63996 23.36 2.66663 16 2.66663ZM16 6.66663C18.2134 6.66663 20 8.45329 20 10.6666C20 12.88 18.2134 14.6666 16 14.6666C13.7867 14.6666 12 12.88 12 10.6666C12 8.45329 13.7867 6.66663 16 6.66663ZM16 25.6C12.6667 25.6 9.72002 23.8933 8.00002 21.3066C8.04002 18.6533 13.3334 17.2 16 17.2C18.6534 17.2 23.96 18.6533 24 21.3066C22.28 23.8933 19.3334 25.6 16 25.6Z"
                      fill="white"
                    />
                  </svg>
                </Link>
              )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
